import script from "./InvoicingDisplaySettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./InvoicingDisplaySettings.vue?vue&type=script&setup=true&lang=ts"

import "./InvoicingDisplaySettings.vue?vue&type=style&index=0&id=48fe92d1&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48fe92d1"]])

export default __exports__